function CPRRecordModel(params) {
    if (!params) params = {};
    var model = {};

    model.ClaimNo = params.ClaimNo;
    model.ClaimantName = params.ClaimantName;
    model.WsCode = params.WsCode;
    model.DateInjured = params.DateInjured;
    model.Closed = params.Closed;
    model.ClaimType = params.ClaimType;
    model.FullClaimsCosts = params.FullClaimsCosts;
    model.ClaimsCosts = params.ClaimsCosts;
    model.R = params.R;
    model.RecoveryAmount = params.RecoveryAmount;
    model.GrossClaimsCosts = params.GrossClaimsCosts;
    model.RtwiWeek = params.RtwiWeek;
    model.RtwiPercent = !params.RtwiPercent ? "0%" : params.RtwiPercent + "%";
    model.RtwiAmount = !params.RtwiAmount ? "0" : params.RtwiAmount;
    model.Total = params.Total;
    model.BrokerNumber = !params.BrokerNumber ? "NA" : params.BrokerNumber;
    model.RenewalDate = params.RenewalDate;
    model.PolicyAddress = params.PolicyAddress;

    return model;
}